import React from "react";
// import { AiOutlineCalendar, AiOutlineShoppingCart, AiOutlineAreaChart, AiOutlineBarChart, AiOutlineStock } from 'react-icons/ai';
import {
  FiCreditCard,
  FiStar,
  FiShoppingCart,
  FiShoppingBag,
} from "react-icons/fi";
import {
  BsBoxSeam,
  BsCurrencyDollar,
  BsChatLeft,
  BsSpeedometer2,
} from "react-icons/bs";
// import { BiColorFill } from 'react-icons/bi';
import { IoMdContacts } from "react-icons/io";
import { RiBuilding2Fill, RiContactsLine } from "react-icons/ri";
import { MdOutlineSupervisorAccount } from "react-icons/md";
import { HiOutlineRefresh } from "react-icons/hi";
import { TiTick } from "react-icons/ti";
import { GiSuitcase } from "react-icons/gi";
import {
  FaHandshakeSlash,
  FaMoneyCheckAlt,
  FaUserTie,
  FaRegBuilding,
  FaUserGraduate,
  FaBriefcase,
  FaLayerGroup,
  FaQuestionCircle,
  FaBalanceScale,
  FaHandHoldingUsd,
  FaWallet,
  FaUsersCog,
  FaUserFriends,
  FaComments,
  FaFlag,
  FaCog,
  FaUsers,
  FaTachometerAlt,
  FaIdCard,
} from "react-icons/fa";
import { FaMessage } from "react-icons/fa6";
import { GrLocation } from "react-icons/gr";

import dirham from "./dirham.png";
// import product8 from './product8.jpg';
export const DirhamIcon = () => (
  // <span style={{ fontWeight: "bold", fontSize: "1.2rem" }}>د.إ</span>
  <img src={dirham} width={30} />
);

export const gridOrderImage = (props) => (
  <div>
    <img
      className="rounded-xl h-20 md:ml-3"
      src={props.ProductImage}
      alt="order-item"
    />
  </div>
);

export const gridOrderStatus = (props) => (
  <button
    type="button"
    style={{ background: props.StatusBg }}
    className="text-white py-1 px-2 capitalize rounded-2xl text-md"
  >
    {props.Status}
  </button>
);

export const kanbanGrid = [
  { headerText: "To Do", keyField: "Open", allowToggle: true },

  { headerText: "In Progress", keyField: "InProgress", allowToggle: true },

  {
    headerText: "Testing",
    keyField: "Testing",
    allowToggle: true,
    isExpanded: false,
  },

  { headerText: "Done", keyField: "Close", allowToggle: true },
];
const gridEmployeeProfile = (props) => (
  <div className="flex items-center gap-2">
    <img
      className="rounded-full w-10 h-10"
      src={props.EmployeeImage}
      alt="employee"
    />
    <p>{props.Name}</p>
  </div>
);

const gridEmployeeCountry = (props) => (
  <div className="flex items-center justify-center gap-2">
    <GrLocation />
    <span>{props.Country}</span>
  </div>
);
export const EditorData = () => (
  <div>
    <h3>
      Try React React has been designed from the start for gradual adoption, and
      you can use as little or as much React as you need. Whether you want to
      get a taste of React, add some interactivity to a simple HTML page, or
      start a complex React-powered app, the links in this section will help you
      get started. Online Playgrounds If you’re interested in playing around
      with React, you can use an online code playground. Try a Hello World
      template on CodePen, CodeSandbox, or Stackblitz. If you prefer to use your
      own text editor, you can also download this HTML file, edit it, and open
      it from the local filesystem in your browser. It does a slow runtime code
      transformation, so we’d only recommend using this for simple demos. Add
      React to a Website You can add React to an HTML page in one minute. You
      can then either gradually expand its presence, or keep it contained to a
      few dynamic widgets. Create a New React App When starting a React project,
      a simple HTML page with script tags might still be the best option. It
      only takes a minute to set up! As your application grows, you might want
      to consider a more integrated setup. There are several JavaScript
      toolchains we recommend for larger applications. Each of them can work
      with little to no configuration and lets you take full advantage of the
      rich React ecosystem. Learn how. Learn React People come to React from
      different backgrounds and with different learning styles. Whether you
      prefer a more theoretical or a practical approach, we hope you’ll find
      this section helpful. If you prefer to learn by doing, start with our
      practical tutorial. If you prefer to learn concepts step by step, start
      with our guide to main concepts. Like any unfamiliar technology, React
      does have a learning curve. With practice and some patience, you will get
      the hang of it. First Examples The React homepage contains a few small
      React examples with a live editor. Even if you don’t know anything about
      React yet, try changing their code and see how it affects the result.
      React for Beginners If you feel that the React documentation goes at a
      faster pace than you’re comfortable with, check out this overview of React
      by Tania Rascia. It introduces the most important React concepts in a
      detailed, beginner-friendly way. Once you’re done, give the documentation
      another try! React for Designers If you’re coming from a design
      background, these resources are a great place to get started. JavaScript
      Resources The React documentation assumes some familiarity with
      programming in the JavaScript language. You don’t have to be an expert,
      but it’s harder to learn both React and JavaScript at the same time. We
      recommend going through this JavaScript overview to check your knowledge
      level. It will take you between 30 minutes and an hour but you will feel
      more confident learning React.
    </h3>
  </div>
);
const customerGridImage = (props) => (
  <div className="image flex gap-4">
    <img
      className="rounded-full w-10 h-10"
      src={props.CustomerImage}
      alt="employee"
    />
    <div>
      <p>{props.CustomerName}</p>
      <p>{props.CustomerEmail}</p>
    </div>
  </div>
);

const customerGridStatus = (props) => (
  <div className="flex gap-2 justify-center items-center text-gray-700 capitalize">
    <p
      style={{ background: props.StatusBg }}
      className="rounded-full h-3 w-3"
    />
    <p>{props.Status}</p>
  </div>
);
export const areaPrimaryXAxis = {
  valueType: "DateTime",
  labelFormat: "y",
  majorGridLines: { width: 0 },
  intervalType: "Years",
  edgeLabelPlacement: "Shift",
  labelStyle: { color: "gray" },
};

export const areaPrimaryYAxis = {
  labelFormat: "{value}%",
  lineStyle: { width: 0 },
  maximum: 4,
  interval: 1,
  majorTickLines: { width: 0 },
  minorTickLines: { width: 0 },
  labelStyle: { color: "gray" },
};
export const barPrimaryXAxis = {
  valueType: "Category",
  interval: 1,
  majorGridLines: { width: 0 },
};
export const barPrimaryYAxis = {
  majorGridLines: { width: 0 },
  majorTickLines: { width: 0 },
  lineStyle: { width: 0 },
  labelStyle: { color: "transparent" },
};

export const barChartData = [
  [
    { x: "USA", y: 46 },
    { x: "GBR", y: 27 },
    { x: "CHN", y: 26 },
  ],
  [
    { x: "USA", y: 37 },
    { x: "GBR", y: 23 },
    { x: "CHN", y: 18 },
  ],
  [
    { x: "USA", y: 38 },
    { x: "GBR", y: 17 },
    { x: "CHN", y: 26 },
  ],
];

export const barCustomSeries = [
  {
    dataSource: barChartData[0],
    xName: "x",
    yName: "y",
    name: "Gold",
    type: "Column",
    marker: {
      dataLabel: {
        visible: true,
        position: "Top",
        font: { fontWeight: "600", color: "#ffffff" },
      },
    },
  },
  {
    dataSource: barChartData[1],
    xName: "x",
    yName: "y",
    name: "Silver",
    type: "Column",
    marker: {
      dataLabel: {
        visible: true,
        position: "Top",
        font: { fontWeight: "600", color: "#ffffff" },
      },
    },
  },
  {
    dataSource: barChartData[2],
    xName: "x",
    yName: "y",
    name: "Bronze",
    type: "Column",
    marker: {
      dataLabel: {
        visible: true,
        position: "Top",
        font: { fontWeight: "600", color: "#ffffff" },
      },
    },
  },
];
export const colorMappingData = [
  [
    { x: "Jan", y: 6.96 },
    { x: "Feb", y: 8.9 },
    { x: "Mar", y: 12 },
    { x: "Apr", y: 17.5 },
    { x: "May", y: 22.1 },
    { x: "June", y: 25 },
    { x: "July", y: 29.4 },
    { x: "Aug", y: 29.6 },
    { x: "Sep", y: 25.8 },
    { x: "Oct", y: 21.1 },
    { x: "Nov", y: 15.5 },
    { x: "Dec", y: 9.9 },
  ],
  ["#FFFF99"],
  ["#FFA500"],
  ["#FF4040"],
];

export const rangeColorMapping = [
  { label: "1°C to 10°C", start: "1", end: "10", colors: colorMappingData[1] },

  {
    label: "11°C to 20°C",
    start: "11",
    end: "20",
    colors: colorMappingData[2],
  },

  {
    label: "21°C to 30°C",
    start: "21",
    end: "30",
    colors: colorMappingData[3],
  },
];

export const ColorMappingPrimaryXAxis = {
  valueType: "Category",
  majorGridLines: { width: 0 },
  title: "Months",
};

export const ColorMappingPrimaryYAxis = {
  lineStyle: { width: 0 },
  majorTickLines: { width: 0 },
  minorTickLines: { width: 0 },
  labelFormat: "{value}°C",
  title: "Temperature",
};

export const FinancialPrimaryXAxis = {
  valueType: "DateTime",
  minimum: new Date("2016, 12, 31"),
  maximum: new Date("2017, 9, 30"),
  crosshairTooltip: { enable: true },
  majorGridLines: { width: 0 },
};

export const FinancialPrimaryYAxis = {
  title: "Price",
  minimum: 100,
  maximum: 180,
  interval: 20,
  lineStyle: { width: 0 },
  majorTickLines: { width: 0 },
};

export const LinePrimaryXAxis = {
  valueType: "DateTime",
  labelFormat: "y",
  intervalType: "Years",
  edgeLabelPlacement: "Shift",
  majorGridLines: { width: 0 },
  background: "white",
};

export const LinePrimaryYAxis = {
  labelFormat: "{value}%",
  rangePadding: "None",
  minimum: 0,
  maximum: 100,
  interval: 20,
  lineStyle: { width: 0 },
  majorTickLines: { width: 0 },
  minorTickLines: { width: 0 },
};

export const customersGrid = [
  { type: "checkbox", width: "50" },
  {
    headerText: "Name",
    width: "150",
    template: customerGridImage,
    textAlign: "Center",
  },
  {
    field: "ProjectName",
    headerText: "Project Name",
    width: "150",
    textAlign: "Center",
  },
  {
    field: "Status",
    headerText: "Status",
    width: "130",
    format: "yMd",
    textAlign: "Center",
    template: customerGridStatus,
  },
  {
    field: "Weeks",
    headerText: "Weeks",
    width: "100",
    format: "C2",
    textAlign: "Center",
  },
  {
    field: "Budget",
    headerText: "Budget",
    width: "100",
    format: "yMd",
    textAlign: "Center",
  },

  {
    field: "Location",
    headerText: "Location",
    width: "150",
    textAlign: "Center",
  },

  {
    field: "CustomerID",
    headerText: "Customer ID",
    width: "120",
    textAlign: "Center",
    isPrimaryKey: true,
  },
];

export const employeesGrid = [
  {
    headerText: "Employee",
    width: "150",
    template: gridEmployeeProfile,
    textAlign: "Center",
  },
  { field: "Name", headerText: "", width: "0", textAlign: "Center" },
  {
    field: "Title",
    headerText: "Designation",
    width: "170",
    textAlign: "Center",
  },
  {
    headerText: "Country",
    width: "120",
    textAlign: "Center",
    template: gridEmployeeCountry,
  },

  {
    field: "HireDate",
    headerText: "Hire Date",
    width: "135",
    format: "yMd",
    textAlign: "Center",
  },

  {
    field: "ReportsTo",
    headerText: "Reports To",
    width: "120",
    textAlign: "Center",
  },
  {
    field: "EmployeeID",
    headerText: "Employee ID",
    width: "125",
    textAlign: "Center",
  },
];

export const links = [
  // {
  //   title: 'Dashboard',
  //   links: [
  //     {
  //       name: 'ecommerce',
  //       icon: <FiShoppingBag />,
  //     },
  //   ],
  // },

  {
    title: "Pages",
    links: [
      {
        name: "onboarding",
        icon: <IoMdContacts />,
      },
      {
        name: "users",
        icon: <IoMdContacts />,
      },
      {
        name: "employees",
        icon: <IoMdContacts />,
      },
      {
        name: "customers",
        icon: <RiContactsLine />,
      },
      {
        name: "companies",
        icon: <RiBuilding2Fill />,
      },
      {
        name: "categories",
        icon: <RiBuilding2Fill />,
        //   children: [
        //   {
        //     name: 'categories',
        //     icon: <RiBuilding2Fill />,
        //   },
        //   {
        //     name: 'main_categories',
        //     icon: <RiBuilding2Fill />,
        //   },
        // ],
      },
      {
        name: "geeks",
        icon: <IoMdContacts />,
      },
      {
        name: "jobs",
        icon: <RiBuilding2Fill />,
        // children: [
        //   {
        //     name: 'active_jobs',
        //     icon: <RiBuilding2Fill />,
        //   },
        //   {
        //     name: 'schedule_jobs',
        //     icon: <RiBuilding2Fill />,
        //   },
        // ],
      },
      {
        name: "bookings",
        icon: <RiBuilding2Fill />,
      },

      {
        name: "disputes",
        icon: <FaHandshakeSlash />,
      },
      {
        name: "report-issues",
        icon: <FaHandshakeSlash />,
      },
      {
        name: "fines",
        icon: <FaMoneyCheckAlt />,
      },
      {
        name: "notifications",
        icon: <RiBuilding2Fill />,
      },
      {
        name: "settings",
        icon: <RiBuilding2Fill />,
      },
      {
        name: "activity-log",
        title: "Activity Log",
        icon: <FaCog />,
      },
    ],
  },
];

const SuperAdminSidebar = [
  {
    title: "Dashboard",
    links: [
      {
        name: "dashboard",
        icon: <FaTachometerAlt />,
      },
    ],
  },

  {
    title: "Pages",
    links: [
      {
        name: "customers",
        icon: <FaUsers />,
      },
      {
        name: "companies",
        icon: <RiBuilding2Fill />,
      },
      {
        name: "geeks",
        icon: <FaUserGraduate />,
      },
      {
        name: "jobs",
        icon: <FaBriefcase />,
      },
      {
        name: "services",
        icon: <FaLayerGroup />,
        children: [
          {
            name: "categories",
            title: "all services",
            icon: <FaLayerGroup />,
          },
          {
            name: "main-categories",
            title: "main services",
            icon: <FaLayerGroup />,
          },
        ],
      },
      {
        name: "fines",
        title: "fines",
        icon: <FaHandHoldingUsd />,
      },
      {
        name: "wallets",
        icon: <FaWallet />,
        children: [
          {
            name: "wallets",
            title: "all wallets",
            icon: <FaWallet />,
          },
          {
            name: "withdrawal-requests",
            title: "withdrawal request",
            icon: <FaHandHoldingUsd />,
          },
          {
            name: "transactions",
            title: "all transactions",
            icon: <FaHandHoldingUsd />,
          },
          {
            name: "wallet-audit-log",
            title: "wallet Audit Log",
            icon: <FaHandHoldingUsd />,
          },
        ],
      },
      {
        name: "Secondary wallets",
        icon: <FaWallet />,
        children: [
          {
            name: "secondary-wallets",
            title: "wallets",
            icon: <FaWallet />,
          },
          {
            name: "statement-cycles",
            title: "employee statement cycle",
            icon: <FaWallet />,
          },
        ],
      },
      {
        name: "kyc-account-connect",
        title: "KYC Account Connect",
        icon: <FaIdCard />,
      },
      {
        name: "Dispute",
        icon: <FaWallet />,
        children: [
          {
            name: "disputes",
            title: "disputes",
            icon: <FaBalanceScale />,
          },
          {
            name: "reportissues",
            title: "report Issue",
            icon: <FaBalanceScale />,
          },
          {
            name: "no-show-cases",
            title: "no show cases",
            icon: <FaBalanceScale />,
          },
          {
            name: "pausejob",
            title: "pause job",
            icon: <FaBalanceScale />,
          },
        ],
      },
      {
        name: "roles",
        icon: <FaUsersCog />,
      },
      {
        name: "refer-friend-list",
        title: "Refer a Friend",
        icon: <FaUserFriends />,
      },
      
      {
        name: "notifications",
        title: "Notifications",
        icon: <FaComments />,
      },

      {
        name: "inbox",
        title: "inbox",
        icon: <FaComments />,
        children: [
          {
            name: "chat",
            title: "chat",
            icon: <FaComments />,
          },
          {
            name: "chat-reports",
            title: "chat reports",
            icon: <FaFlag />,
          },
        ],
      },
      {
        name: "help menu",
        icon: <FaQuestionCircle />,
        children: [
          {
            name: "faqcategories",
            title: "faq categories",
            icon: <FaQuestionCircle />,
          },
          {
            name: "faqs",
            title: "faqs",
            icon: <FaQuestionCircle />,
          },
          {
            name: "privacypolicy",
            title: "privacy policy",
            icon: <FaBalanceScale />,
          },
          {
            name: "termsandconditions",
            title: "terms and conditions",
            icon: <FaBalanceScale />,
          },
        ],
      },
      {
        name: "activity-log",
        title: "Activity Log",
        icon: <FaCog />,
      },
      {
        name: "settings",
        icon: <FaCog />,
      },
    ],
  },
];

const CompanyAdminSidebar = [
  // {
  //   title: 'Dashboard',
  //   links: [
  //     {
  //       name: 'ecommerce',
  //       icon: <FiShoppingBag />,
  //     },
  //   ],
  // },

  {
    title: "Pages",
    links: [
      {
        name: "users",
        icon: <IoMdContacts />,
      },
      {
        name: "employees",
        icon: <IoMdContacts />,
      },
      {
        name: "customers",
        icon: <RiContactsLine />,
      },

      {
        name: "categories",
        icon: <RiBuilding2Fill />,
      },
      {
        name: "geeks",
        icon: <IoMdContacts />,
      },
      {
        name: "jobs",
        icon: <RiBuilding2Fill />,
      },
      {
        name: "bookings",
        icon: <RiBuilding2Fill />,
      },
      {
        name: "notifications",
        icon: <RiBuilding2Fill />,
      },
    ],
  },
];

const CompanyOnBoarding = [
  {
    title: "Pages",
    links: [
      {
        name: "onboarding",
        icon: <IoMdContacts />,
      },
    ],
  },
];

export const getlinks = (role, status) => {
  if (role?.includes("company")) {
    if (status === "approved") return CompanyAdminSidebar;
    else return CompanyOnBoarding;
  } else {
    return SuperAdminSidebar;
  }
};

export const getEarningData = (data) => {
  return [
    {
      icon: <FaUserTie />,
      amount: String(data.customers_count ?? 0),
      title: "Customers",
      iconColor: "white",
      iconBg: "#E5FAFB",
      cardColor: "#FDE047", // Hex color for yellow-300
      pcColor: "red-600",
      route: "/customers",
    },
    {
      icon: <FaRegBuilding />,
      amount: String(data.companies_count ?? 0),
      title: "Companies",
      iconColor: "white",
      iconBg: "#FFEBE6",
      cardColor: "#FCA5A5", // Hex color for red-300
      pcColor: "green-600",
      route: "/companies",
      filters: { tab: "all" },
    },
    {
      icon: <GiSuitcase />,
      amount: String(data.pending_jobs ?? 0),
      title: "Pending Jobs",
      iconColor: "white",
      iconBg: "#FFF8E1",
      cardColor: "#FDBA74", // Hex color for orange-300
      pcColor: "green-600",
      route: "/jobs",
      filters: { status: "pending" },
    },
    {
      icon: <HiOutlineRefresh />,
      amount: String(data.active_jobs ?? 0),
      title: "Active Jobs",
      iconColor: "white",
      iconBg: "rgb(235, 250, 242)",
      cardColor: "#86EFAC", // Hex color for green-300
      pcColor: "red-600",
      route: "/jobs",
      filters: { status: "active" },
    },
    {
      icon: <HiOutlineRefresh />,
      amount: String(data.inactive_jobs ?? 0),
      title: "Inactive Jobs",
      iconColor: "white",
      iconBg: "rgb(235, 250, 242)",
      cardColor: "#D8B4FE", // Hex color for purple-300
      pcColor: "red-600",
      route: "/jobs",
      filters: { status: "inactive" },
    },
    {
      icon: <HiOutlineRefresh />,
      amount: String(data.suspended_jobs ?? 0),
      title: "Suspended Jobs",
      iconColor: "white",
      iconBg: "rgb(235, 250, 242)",
      cardColor: "#CBD5E1", // Hex color for slate-300
      pcColor: "red-600",
      route: "/jobs",
      filters: { status: "suspended" },
    },
    {
      icon: <MdOutlineSupervisorAccount />,
      amount: String(data.geeks_count ?? 0),
      title: "Geeks",
      iconColor: "white",
      iconBg: "#E5FAFB",
      cardColor: "#3B82F6", // Hex color for blue-500
      pcColor: "red-600",
      route: "/geeks",
      filters: { tab: "all" },
    },
    {
      icon: <MdOutlineSupervisorAccount />,
      amount: String(data.geeks_joined_this_month ?? 0),
      title: "Geeks Joined This Month",
      iconColor: "white",
      iconBg: "#E5FAFB",
      cardColor: "#F97316", // Hex color for orange-500
      pcColor: "red-600",
      route: "/geeks",
      filters: { tab: "all" },
    },
    {
      icon: <FaUserTie />,
      amount: String(data.customers_joined_this_month ?? 0),
      title: "Customers Joined This Month",
      iconColor: "white",
      iconBg: "#E5FAFB",
      cardColor: "#F59E0B", // Hex color for yellow-500
      pcColor: "red-600",
      route: "/customers",
    },
    {
      icon: <FaRegBuilding />,
      amount: String(data.companies_joined_this_month ?? 0),
      title: "Companies Joined This Month",
      iconColor: "white",
      iconBg: "#FFEBE6",
      cardColor: "#F59E0B", // Hex color for yellow-500
      pcColor: "red-600",
      route: "/companies",
      filters: { tab: "all" },
    },
  ];
};
export const paymentSourceStyles = {
  card: {
    icon: <FiCreditCard />,
    iconColor: "rgb(255, 244, 229)",
    iconBg: "rgb(254, 201, 15)",
    pcColor: "green-600",
  },
  Stripe: {
    icon: <DirhamIcon />,
    iconColor: "rgb(228, 106, 118)",
    iconBg: "rgb(255, 244, 229)",
    pcColor: "green-600",
  },
  Paypal: {
    icon: <DirhamIcon />,
    iconColor: "#03C9D7",
    iconBg: "#E5FAFB",
    pcColor: "green-600",
  },
};
export const themeColors = [
  {
    name: "blue-theme",
    color: "#1A97F5",
  },
  {
    name: "green-theme",
    color: "#03C9D7",
  },
  {
    name: "purple-theme",
    color: "#7352FF",
  },
  {
    name: "red-theme",
    color: "#FF5C8E",
  },
  {
    name: "indigo-theme",
    color: "#1E4DB7",
  },
  {
    color: "#FB9678",
    name: "orange-theme",
  },
];

export const userProfileData = [
  {
    icon: <FaMessage />,
    title: "My Inbox",
    desc: "Messages & Emails",
    iconColor: "rgb(0, 194, 146)",
    iconBg: "rgb(235, 250, 242)",
  },
];
